function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 0C4.9 0 4 0.899999 4 2V30C4 31.1 4.9 31.9999 6 31.9999H26C27.1 31.9999 28 31.1 28 30V7.99999L20 0H6Z",
  fill: "#F2F3F7"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 2C4.5 1.17614 5.17614 0.5 6 0.5H19.7929L27.5 8.20709V30C27.5 30.8238 26.8238 31.4999 26 31.4999H6C5.17614 31.4999 4.5 30.8238 4.5 30V2Z",
  stroke: "#7F8C99",
  strokeOpacity: 0.35
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M22 7.99999H28L20 0V5.99999C20 7.09999 20.9 7.99999 22 7.99999Z",
  fill: "#BBC1C7"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M28 14L22 8H28V14Z",
  fill: "#BBC1C7"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24 26C24 26.55 23.55 27 23 27H1C0.45 27 0 26.55 0 26V16C0 15.45 0.45 15 1 15H23C23.55 15 24 15.45 24 16V26Z",
  fill: "#00bb77"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.39391 19.0424L5.43053 20.6575L6.48728 19.0424H7.8208L6.17025 21.4312L7.88622 23.91H6.5527L5.44562 22.2275L4.33855 23.91H3L4.71093 21.4312L3.06542 19.0424H4.39391Z",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.9494 17V23.91H8.73162V17H9.9494Z",
  fill: "white"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3324 22.5919C14.3324 22.4839 14.3022 22.3865 14.2418 22.2995C14.1814 22.2095 14.0657 22.1285 13.8946 22.0566C13.7269 21.9846 13.4786 21.9186 13.1498 21.8586C12.8613 21.8016 12.5963 21.7341 12.3548 21.6562C12.1166 21.5752 11.9119 21.4777 11.7408 21.3638C11.5698 21.2498 11.4372 21.1148 11.3433 20.9589C11.2494 20.8029 11.2024 20.623 11.2024 20.419C11.2024 20.2211 11.251 20.0336 11.3483 19.8567C11.4456 19.6797 11.5848 19.5238 11.766 19.3888C11.9472 19.2539 12.1669 19.1474 12.4252 19.0694C12.6869 18.9914 12.9788 18.9524 13.3008 18.9524C13.7571 18.9524 14.1479 19.0214 14.4733 19.1594C14.8021 19.2943 15.0537 19.4788 15.2281 19.7127C15.4026 19.9437 15.4898 20.2046 15.4898 20.4955H14.277C14.277 20.3665 14.2401 20.2466 14.1663 20.1356C14.0959 20.0216 13.9885 19.9302 13.8443 19.8612C13.7 19.7892 13.5189 19.7532 13.3008 19.7532C13.0928 19.7532 12.92 19.7832 12.7825 19.8432C12.6483 19.9002 12.5477 19.9751 12.4806 20.0681C12.4168 20.1611 12.385 20.2631 12.385 20.374C12.385 20.455 12.4017 20.5285 12.4353 20.5945C12.4722 20.6575 12.5326 20.7159 12.6164 20.7699C12.7003 20.8209 12.8144 20.8689 12.9586 20.9139C13.1062 20.9589 13.2907 21.0024 13.5122 21.0443C13.9282 21.1223 14.2854 21.2228 14.584 21.3458C14.8859 21.4657 15.1174 21.6217 15.2784 21.8136C15.4395 22.0026 15.52 22.2425 15.52 22.5334C15.52 22.7494 15.468 22.9473 15.364 23.1272C15.2633 23.3042 15.1157 23.4587 14.9212 23.5906C14.7266 23.7196 14.4934 23.8201 14.2217 23.892C13.9533 23.964 13.6514 24 13.3159 24C12.8228 24 12.4051 23.922 12.0629 23.7661C11.7207 23.6071 11.4607 23.4047 11.2829 23.1587C11.1085 22.9098 11.0212 22.6519 11.0212 22.385H12.1937C12.2072 22.5859 12.2692 22.7464 12.3799 22.8663C12.494 22.9833 12.6349 23.0688 12.8026 23.1228C12.9737 23.1737 13.1498 23.1992 13.331 23.1992C13.5491 23.1992 13.7319 23.1737 13.8795 23.1228C14.0271 23.0688 14.1395 22.9968 14.2167 22.9068C14.2938 22.8138 14.3324 22.7089 14.3324 22.5919Z",
  fill: "white"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5077 19.0424L18.5443 20.6575L19.6011 19.0424H20.9346L19.284 21.4312L21 23.91H19.6665L18.5594 22.2275L17.4523 23.91H16.1138L17.8247 21.4312L16.1792 19.0424H17.5077Z",
  fill: "white"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M23 27H4V28H23C23.55 28 24 27.55 24 27V26C24 26.55 23.55 27 23 27Z",
  fill: "#BBC1C7"
});
const SvgXlsxFile = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 32,
  viewBox: "0 0 28 32",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgXlsxFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/xlsx-file.a8f167cb.svg";
export { ForwardRef as ReactComponent };